import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

// SOFTCAT 디자인 시스템 관리자 사이드바 (sc-sidenav)
const GROUPS = [
    {
        label: "운영",
        items: [
            ["/admin", "구독 생성"],
            ["/admin/orders", "주문 관리"],
            ["/admin/users", "사용자 관리"],
        ],
    },
    {
        label: "상품 · 혜택",
        items: [
            ["/admin/products", "상품 관리"],
            ["/admin/coupons", "쿠폰 관리"],
        ],
    },
    {
        label: "사이트",
        items: [
            ["/admin/portfolio", "포트폴리오 관리"],
            ["/admin/posts", "블로그 관리"],
            ["/admin/settings", "웹 사이트 설정"],
            ["/", "메인 페이지"],
        ],
    },
];

const BREAKPOINT = 1100;

const AdminSidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isMobile, setIsMobile] = useState(() => window.innerWidth < BREAKPOINT);
    const [isOpen, setIsOpen] = useState(() => window.innerWidth >= BREAKPOINT);

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < BREAKPOINT;
            setIsMobile(mobile);
            setIsOpen(!mobile);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const go = (path) => {
        navigate(path);
        if (isMobile) setIsOpen(false);
        window.scrollTo(0, 0);
    };

    return (
        <>
            {isMobile && (
                <button
                    type="button"
                    className="sc-btn sc-btn--secondary sc-btn--icononly sch-adminToggle"
                    onClick={() => setIsOpen((v) => !v)}
                    aria-label="관리자 메뉴"
                    aria-expanded={isOpen}
                >
                    {isOpen ? <X size={18} /> : <Menu size={18} />}
                </button>
            )}

            {isOpen && (
                <nav className="sc-sidenav sch-adminNav" aria-label="관리자 메뉴">
                    <div className="sc-sidenav__group">관리자 메뉴</div>
                    {GROUPS.map(({ label, items }) => (
                        <React.Fragment key={label}>
                            <div className="sc-sidenav__group">{label}</div>
                            {items.map(([path, text]) => (
                                <button
                                    key={path}
                                    type="button"
                                    className={`sc-sidenav__item${location.pathname === path ? " active" : ""}`}
                                    onClick={() => go(path)}
                                >
                                    {text}
                                </button>
                            ))}
                        </React.Fragment>
                    ))}
                </nav>
            )}
        </>
    );
};

export default AdminSidebar;
